import script from "./psiStoreGoodsOutAndShopInStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./psiStoreGoodsOutAndShopInStatistics.vue?vue&type=script&setup=true&lang=js"

import "./psiStoreGoodsOutAndShopInStatistics.vue?vue&type=style&index=0&id=86afe744&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86afe744"]])

export default __exports__